import React from 'react';

interface AnimatedChevronProps {
  isExpanded: boolean;
  className?: string;
  size?: number;
}

const AnimatedChevron: React.FC<AnimatedChevronProps> = ({
  isExpanded,
  className = '',
  size = 12
}) => {
  return (
    <svg
      className={`animated-chevron ${isExpanded ? 'expanded' : ''} ${className}`}
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="currentColor"
    >
      <path
        d="M3 4.5L6 7.5L9 4.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

export default AnimatedChevron;